import { Button, Modal, Stack, Text, Title } from "@mantine/core"
import {
	AEM_DICTIONARY_COLLECTIONS,
	useAEMDictionary
} from "@AEM/hooks/useAEMDictionary"
import styles from "./ComplianceRequiredModal.module.css"

interface ComplianceRequiredModalProps {
	opened: boolean
	onContinue: () => void
}

export function ComplianceRequiredModal({
	opened,
	onContinue
}: ComplianceRequiredModalProps) {
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)

	return (
		<Modal.Root
			opened={opened}
			onClose={onContinue}
			centered
			size={700}
			closeOnClickOutside={false}
			closeOnEscape={false}
			classNames={{ content: styles.modalContent }}
			zIndex={500}
		>
			<Modal.Overlay opacity={0} />
			<Modal.Content>
				<Modal.Header p="10px 0" w="100%">
					<Stack align="center" p="26px" w="100%">
						<Title order={1} fz={{ base: 26, sm: 26 }} fw={600} ta="center">
							{dictionary?.hsModelTitle ?? ""}
						</Title>
					</Stack>
				</Modal.Header>
				<Modal.Body p={0}>
					<Stack
						w="100%"
						gap={0}
						maw={780}
						p={{ base: "0 24px 32px", sm: "0 50px 40px 50px" }}
					>
						<Text fz={{ base: 14, sm: 16 }} lh={1.5} mb="md">
							{dictionary?.hsModelDescription1 ?? ""}
						</Text>
						<Text fz={{ base: 14, sm: 16 }} lh={1.5} mb="md">
							{dictionary?.hsModelDescription2 ?? ""}
						</Text>
						{dictionary?.hsModelDescription3 ? (
							<Text fz={{ base: 14, sm: 16 }} lh={1.5}>
								{dictionary.hsModelDescription3}
							</Text>
						) : null}
					</Stack>
					<Stack align="center" p="20px 0 40px 0" w="100%">
						<Button size="lg" variant="dark-blue" onClick={onContinue}>
							{dictionary?.continueButton ?? ""}
						</Button>
					</Stack>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	)
}
